import { useEffect, useState } from "react";
import { Download } from "lucide-react";

// On phones the nav's "Download Now" button is hidden (it only shows at sm: and up) and the
// mobile version lives inside the hamburger menu — so once someone scrolls past the hero there
// is no visible way to act. This pins one back to the bottom of the screen.
//
// Hidden until the hero is behind you, so it never competes with the hero's own CTA, and
// md:hidden so desktop keeps the nav button it already has.
export const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goDownload = () => {
    document.getElementById("download")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-white/10 bg-[#0a0a0a]/95 backdrop-blur px-4 py-3 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      aria-hidden={!visible}
      data-testid="sticky-mobile-cta"
    >
      <button
        type="button"
        onClick={goDownload}
        tabIndex={visible ? 0 : -1}
        className="flex w-full items-center justify-center gap-2 bg-orange-500 py-3.5 text-xs font-black uppercase tracking-[0.2em] text-black transition-colors hover:bg-orange-400"
      >
        <Download className="h-4 w-4" />
        Download Free
      </button>
      <p className="mt-2 text-center text-[9px] uppercase tracking-[0.2em] text-zinc-500">
        Free to download · Plans from $5
      </p>
    </div>
  );
};
